import '../styles/product.css';

const ProductImageComponent = ({ item, greyscale }) => {
    const handleError = (e) => {
      e.target.src = "/assets/products/Default.png"; // Set the fallback image source
    };
  
    const imageStyle = {
      filter: greyscale ? "grayscale(100%)" : "none", // Apply greyscale filter if greyscale is true
    };
  
    if (item.type === "Single") {
      return <div className='product-container'>
        <img className="product-img" src={item.imageUrl} alt={item.name} style={imageStyle} />
      </div>
    }
  
    return (
      <div className='product-container'>
        <img
          className="product-img"
          src={`/assets/products/${item.name}.png`}
          onError={handleError}
          alt={item.name}
          style={imageStyle} // Apply greyscale based on the prop
        />
        </div>

    );
  };
  
  export default ProductImageComponent;